module.exports = __webpack_public_path__ + "static/metaloopBannerText-bd223a8f4c603511ef4596beb6b70960.svg";